var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportIssue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.812V17.1274",
    stroke: "currentColor",
    strokeWidth: 1.27569,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0003 25.0045H8.55805C4.86917 25.0045 3.32771 22.368 5.11368 19.1469L8.43048 13.1724L11.5559 7.55936C13.4482 4.14688 16.5524 4.14688 18.4447 7.55936L21.5701 13.183L24.8869 19.1575C26.6729 22.3787 25.1208 25.0151 21.4426 25.0151H15.0003V25.0045Z",
    stroke: "currentColor",
    strokeWidth: 1.27569,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9937 20.3164H15.0032",
    stroke: "currentColor",
    strokeWidth: 1.70092,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIssue);
export default __webpack_public_path__ + "static/media/report_issue.982a4ff4.svg";
export { ForwardRef as ReactComponent };